import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { TESTIMONIALS, STATS } from '../../utils/constants';
import { fadeUp, spring, stagger, viewportOnce } from '../../utils/animations';

export default function Testimonials() {
  const [ref, inView] = useInView(viewportOnce);

  return (
    <section className="section-padding relative overflow-hidden">
      <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-gradient-radial-purple opacity-10 gpu" />

      <div className="container-custom relative z-10" ref={ref}>
        {/* Header */}
        <motion.h2
          className="text-4xl sm:text-5xl font-bold text-center text-white mb-16"
          variants={fadeUp}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          transition={spring}
        >
          Real People. Real Results.
        </motion.h2>

        {/* Testimonial cards — staggered */}
        <motion.div
          className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-20"
          variants={stagger(0.12, 0.2)}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
        >
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              className="glass-card p-8 flex flex-col transition-colors duration-300 hover:border-white/[0.15]"
              variants={fadeUp}
              transition={spring}
              whileHover={{
                y: -3,
                transition: { type: 'spring', stiffness: 400, damping: 25 },
              }}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, j) => (
                  <svg key={j} className="w-4 h-4 text-accent-yellow fill-current" viewBox="0 0 20 20">
                    <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                  </svg>
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-white/65 leading-relaxed mb-6 flex-1 text-[15px]">
                &ldquo;{t.quote}&rdquo;
              </blockquote>

              {/* Author */}
              <div className="pt-5 border-t border-white/[0.06]">
                <div className="font-semibold text-white text-sm">{t.author}</div>
                <div className="text-white/35 text-xs mt-0.5">{t.role}</div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Stats bar */}
        <motion.div
          className="glass-card p-8 max-w-4xl mx-auto"
          variants={fadeUp}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          transition={{ ...spring, delay: 0.6 }}
        >
          <div className="grid grid-cols-3 divide-x divide-white/[0.06]">
            {STATS.map((stat, i) => (
              <div key={i} className="text-center px-4">
                <div className="text-3xl lg:text-4xl font-bold bg-gradient-brand bg-clip-text text-transparent">
                  {stat.value}
                </div>
                <div className="text-white/35 text-xs mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
